import React from 'react';
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';

import { FormFeedback } from 'reactstrap';
import GoogleLogo from '../../../assets/images/google.png';
import './Address.css';

class AddressSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      address: '',
    };
    this.onChange = this.onChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  handleSelect = (address, placeId) => {
    console.log(`city: ${address}`);
    this.setState({ address });
    geocodeByAddress(address)
      .then((results) => getLatLng(results[0]))
      .then((latLng) => {
        this.setState({ latLng });
        this.props.input.onChange(this.state);
      })
      .catch((error) => console.error('Error', error));
  };

  onChange = (address) => {
    this.setState({ address });
  };

  componentDidMount() {
    this.setState({
      location: this.props.input.value.location,
      address: this.props.input.value.address,
    });
  }

  render() {
    const inputProps = {
      value: this.state.address,
      onChange: this.onChange,
      placeholder: this.props.placeholder,
    };

    const renderSuggestion = ({ suggestion }) => (
      <div className="address-result">
        <i className="fa fa-map-marker" />
        {suggestion}
      </div>
    );

    const renderFooter = () => (
      <div className="dropdown-footer">
        <div>
          <img src={GoogleLogo} alt="" />
        </div>
      </div>
    );

    const cssClasses = {
      input: 'form-control',
      autocompleteContainer: 'address-result-container',
      root: 'address-wrapper',
    };

    return (
      console.log(this.props.searchOptions),
      (
        <div>
          <PlacesAutocomplete
            inputProps={inputProps}
            classNames={cssClasses}
            renderSuggestion={renderSuggestion}
            onSelect={this.handleSelect}
            renderFooter={renderFooter}
          />
          {this.state.location && (
            <div className="location-result">
              <code>
                {this.state.location.lat} {', '}
                {this.state.location.lng}
              </code>
            </div>
          )}
          {this.props.meta.touched && this.props.meta.error && (
            <FormFeedback style={{ display: 'block' }}>
              {this.props.meta.error}
            </FormFeedback>
          )}
        </div>
      )
    );
  }
}

export default AddressSearch;



// WEBPACK FOOTER //
// ./src/system/fields/AddressSearch/index.jsx